import React from 'react'
import style from './articles.style'

const AuthorizeErrors = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Почему возникает ошибка авторизации</h2>
      <p>Ошибка авторизации может возникнуть в случае отзыва токена доступа приложения Датаспоттер</p>
      <p>Отзыв токена происходит в следующих случаях:</p>
      <ol>
        <li>Токен был отозван владельцем аккаунта</li>
        <li>Срок жизни токена истек</li>
        <li>
          Владелец аккаунта  совершил одно из следующих действий:
          <ol>
            <li>изменил пароль;</li>
            <li>включил или выключил двухфакторную аутентификацию;</li>
            <li>успешно восстановил доступ к аккаунту;</li>
            <li>произвел выход из аккаунта со всех устройств.</li>
          </ol>
        </li>
      </ol>
    </article>
  )
}

export default style(AuthorizeErrors)
